import { render, staticRenderFns } from "./SpecialDimensionFilterButton.vue?vue&type=template&id=07d8fac0&scoped=true&"
import script from "./SpecialDimensionFilterButton.vue?vue&type=script&lang=ts&"
export * from "./SpecialDimensionFilterButton.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialDimensionFilterButton.vue?vue&type=style&index=0&id=07d8fac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8fac0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDivider,VForm,VMenu,VSpacer,VTextField})
